import React from "react";

import OtherBuilder from "../../assets/images/icons/Other Builders.svg";

export const OtherBuilderIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={OtherBuilder}
        alt={alt || "Other Builders"}
    />
);
